import useMountEffect from '@restart/hooks/useMountEffect';
import { RiSpeedUpLine } from 'react-icons/ri';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import actions from '@/actions';
import AirspeedModal from '@/components/modals/calibration/Airspeed';
import { modalManager } from '@/libs/ModalContainer';

const Panel = ({ data: [robot] }) => {
  const dispatch = useDispatch();

  useMountEffect(() => {
    modalManager.show(AirspeedModal, { robot });
    dispatch(actions.command.resetActivePanels());
  });

  return null;
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Airspeed';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = true;
Command.commanderOnly = true;
Command.Icon = RiSpeedUpLine;
Command.Panel = Panel;

export default Command;
